'use strict';

var defineProperty = require('../../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var ButtonCircularProgress = require('./ButtonCircularProgress.js');
var index = require('../../../../node_modules/lodash.debounce/index.js');
var makeStyles = require('../../../Styles/makeStyles.js');
var classNames = require('classnames');
var typographyTheme = require('../../../../Theme/typographyTheme.js');
var useButtonStyles = require('./useButtonStyles.js');
var Button$1 = require('../../../../node_modules/@material-ui/core/esm/Button/Button.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function () {
  return {
    shape: {
      height: 40,
      borderRadius: 100,
      padding: '8px 24px',
      boxShadow: 'none',
      '&:hover': {
        boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'
      }
    },
    largeV2: {
      fontFamily: typographyTheme.FONT_FAMILY,
      fontSize: '1.125rem',
      lineHeight: 1,
      fontWeight: 600
    },
    mediumV2: {
      fontFamily: typographyTheme.FONT_FAMILY,
      fontSize: '1rem',
      lineHeight: 1,
      fontWeight: 600
    },
    smallV2: {
      fontFamily: typographyTheme.FONT_FAMILY,
      fontSize: '.875rem',
      lineHeight: 1.14,
      fontWeight: 600
    }
  };
});

var Button = function Button(_ref) {
  var buttonText = _ref.buttonText,
      color = _ref.color,
      _ref$onClick = _ref.onClick,
      upstreamOnClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      children = _ref.children,
      loading = _ref.loading,
      _ref$disabled = _ref.disabled,
      upstreamDisabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      classes = _ref.classes,
      _ref$circularProgress = _ref.circularProgressProps,
      circularProgressProps = _ref$circularProgress === void 0 ? {} : _ref$circularProgress,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? '' : _ref$version,
      className = _ref.className,
      restOfProps = objectWithoutProperties(_ref, ["buttonText", "color", "onClick", "children", "loading", "disabled", "size", "classes", "circularProgressProps", "version", "className"]);

  // Use callback ensures we keep the same onClick handler over multiple renders
  var onClick = React.useCallback(index(upstreamOnClick, 800, {
    leading: true,
    trailing: false
  }), [upstreamOnClick]);
  var disabled = upstreamDisabled || loading;

  var _useStyles = useStyles(),
      shape = _useStyles.shape,
      smallV2 = _useStyles.smallV2,
      mediumV2 = _useStyles.mediumV2,
      largeV2 = _useStyles.largeV2;

  var _useButtonStyles = useButtonStyles(),
      getButtonColor = _useButtonStyles.getButtonColor;

  var buttonSizeMap = {
    small: smallV2,
    medium: mediumV2,
    large: largeV2
  };
  var buttonColor = getButtonColor(color, version);
  return React__default["default"].createElement(Button$1["default"], _objectSpread({
    color: buttonColor,
    onClick: onClick,
    classes: classes,
    className: version === 'v2' ? classNames__default["default"](shape, className, buttonSizeMap[size]) : className,
    disabled: disabled,
    size: size
  }, restOfProps), buttonText, children, loading && React__default["default"].createElement(ButtonCircularProgress, _objectSpread({
    size: size
  }, circularProgressProps)));
};

module.exports = Button;
